export default function Title(props) {
  return(
    <h2 className="organization__title">{props.content}</h2>
  );
}
